// iClean Field — Field Job Type catalogue (mirrors backend models.FIELD_JOB_TYPES).
// Legacy keys are still rendered for existing jobs but not offered for new ones.
export const FIELD_JOB_TYPES = [
  "between_tenancy", "office", "post_construction", "deep", "one_off", "other",
];

export const JOB_TYPE_LABELS = {
  between_tenancy: "Between Tenancy Clean",
  office: "Office Clean",
  post_construction: "Post Construction Clean",
  deep: "Deep Clean",
  one_off: "One-off Clean",
  other: "Other",
  // legacy values (display only)
  regular: "Regular Clean",
  communal: "Communal Clean",
  deep_clean: "Deep Clean",
  end_of_tenancy: "End of Tenancy",
  post_builders: "Post-Builders Clean",
  emergency: "Emergency Clean",
};

export const jobTypeLabel = (t, key) => {
  if (!key) return "—";
  const fallback = JOB_TYPE_LABELS[key] || key;
  return (t ? t(`jt.${key}`, fallback) : fallback) || fallback;
};
